import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Space,
  Descriptions
} from "antd";
import { SearchOutlined } from '@ant-design/icons';
// import Highlighter from 'react-highlight-words';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import React, { useState, useContext, useEffect, useRef } from "react";
import { ToTopOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Link, useParams } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import moment from "moment";
const Search = Input.Search;
function ViewCoupon() {
  const [searchText, setSearchText] = useState('');
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchedColumn, setSearchedColumn] = useState('');
  const { request } = useRequest()
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [language, setLanguage] = useState('')
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const debouncedSearchText = useDebounce(searchText, 300);
  const searchInput = useRef(null);
  const { confirm } = Modal;
  const params = useParams()
  let commaSeparatedNames = ""

  useEffect(() => {
    console.log(params)
    setLoading(true)
    fetchData(params.id)
  }, [])




  const fetchData = (id) => {
    request({
      url: `/admin/discount-manager/view-coupon/${id}`,
      method: 'PUT',
      onSuccess: (data) => {
        setLoading(false)
        console.log(data.data, "data")
        setList(data.data)
      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  }


  return (
    <Main>
      {/* <Card title="Psychologist Details">
        <Descriptions bordered column={1}>
          <Descriptions.Item label="Type">{list.type}</Descriptions.Item>
          <Descriptions.Item label="Valid Month">{list.validMonth}</Descriptions.Item>
          <Descriptions.Item label="Price"> $ {list ? list.price : '--'}</Descriptions.Item>
          <Descriptions.Item label="Session">{list ? list.session : "---"}</Descriptions.Item>
          <Descriptions.Item label="Status">{list.is_active ? "Active" : "Inactive"}</Descriptions.Item>
          <Descriptions.Item label="Cancellation Date">{list ? (list.cancellationDate) : "---"}</Descriptions.Item>
          <Descriptions.Item label="Due Date">{list ? list.dueDate : '---'}</Descriptions.Item>
          <Descriptions.Item label="Language">{list ? list.language : "---"}</Descriptions.Item>
        </Descriptions>



      </Card> */}
      <Card title="Subscription Details">
        <Row gutter={16}>
          <Col span={12} xs={24} md={12}>
            <div className="view-main-list">
              <div className="view-inner-cls">
                <h5>Title:</h5>
                <h6>{list ? list.title : '--'}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>promoCode:</h5>
                <h6>{list ? list.promoCode : '--'}</h6>
              </div>
              {/* <div className="view-inner-cls">
                <h5>Subscription :</h5>
                <h6>{list ? list.subscription ? list.subscription.type : '--' : "--"}</h6>
              </div> */}
              <div className="view-inner-cls">
                <h5>Max Amount (EUR):</h5>
                <h6>{list ? list.maxAmount : 0}</h6>
              </div>

              <div className="view-inner-cls">
                <h5>No of user:</h5>
                <h6>{list ? list.noOfUser : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>No of use:</h5>
                <h6>{list ? list.noOfUse : "--"}</h6>
              </div>
              {/* <div className="view-inner-cls">
                <h5>End Date:</h5>
                <h6>{list ? moment(list.endDate).format("YYYY-MM-DD") : "--"}</h6>
              </div> */}
              <div className="view-inner-cls">
                <h5>Percentage </h5>
                <h6>{list ? list.percentage + "% " : "--"}</h6>
              </div>


            </div>
          </Col>
          {/* <Col span={12}>
            <div className="view-main-list border-right-0">
              <div className="view-inner-cls">
                <h5>Total Amount:</h5>
                <h6>{0}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Referral Discount:</h5>
                <h6>{0}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Gossip Session:</h5>
                <h6>{list.gossipSession ? list.gossipSession : "No"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Language:</h5>
                <h6>{list.languageId ? list.languageId.name : "English"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Referral Count:</h5>
                <h6>{list ? list.refferalCount : 0}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>No of Click to Buy Subscription:</h5>
                <h6>0</h6>
              </div>
            </div>
          </Col> */}
        </Row>

      </Card>

    </Main>
  );
}


export default ViewCoupon;
